export default __webpack_public_path__ + "static/media/Prologue_AuroraM1.29272f51.svg";